import { ReactElement } from 'react';
import styles from './ProgressBar.module.css';
import { ASSET_PREFIX } from 'utils/constants';
import { getChooseYourPlanBoostValue } from 'utils/ab-test/abTests';

interface Props {
  /** @deprecated No longer needed, as we have chosen a winner */
  variant?: string;
  /** The number of the step that we are currently on. This starts from 1, rather than zero */
  progressBars: number;
  /** @deprecated The total number of bars, however, the variant designs call for a fixed number of named steps */
  numBars?: number;
  /** @deprecated The children to show if the components own variant are not required. This prop won't be needed once
   * we stop using plasmic
   */
  children?: ReactElement;
  /** @deprecated Remove the margin, e.g. when used on EnterLayout. This should be deleted once enter flow is out of plasmic  */
  noBottomMargin?: boolean;
}

const steps = [
  { name: 'Numbers', iconFilename: 'enter-1.svg' },
  { name: 'Days', iconFilename: 'enter-2.svg' },
  { name: 'Boost', iconFilename: 'enter-3.svg' },
  { name: 'Sign up', altName: 'Sign in', iconFilename: 'enter-4.svg' },
  { name: 'Payment', iconFilename: 'enter-5.svg' },
];

const variants = {
  numbers: 'VARIANT1',
  icons: 'VARIANT2',
  ticks: 'VARIANT3',
};

const EnterProgressBar = (props: Props) => {
  const isNumbers = true;
  const isIcons = false;
  const isTicks = false;

  // If we are in the AB test that hides boost, then don't show it
  const stepsToUse =
    getChooseYourPlanBoostValue() === 'V2'
      ? steps.filter((x) => x.name !== 'Boost')
      : steps;

  // If we are in the AB test that hides boost, then subtract 1 from the number of steps that we've completed
  const progressBarToUse =
    getChooseYourPlanBoostValue() === 'V2'
      ? props.progressBars >= 3
        ? props.progressBars - 1
        : props.progressBars
      : props.progressBars;

  return (
    <div
      className={styles.stepContainerOuter}
      style={{ ['--stepContainerTotalSteps' as any]: stepsToUse.length }}
    >
      <div
        className={`${styles.stepContainer} ${props.noBottomMargin ? styles.noBottomMargin : ''} ${isNumbers ? styles.numbers : ''} ${isIcons ? styles.icons : ''} ${isTicks ? styles.ticks : ''} ${styles['stepIndex__' + progressBarToUse]}`}
      >
        {stepsToUse.map((x, index) => {
          return (
            <div
              className={`${styles.step} ${index >= progressBarToUse ? styles.upcoming : ''}`}
            >
              <div className={styles.circle}>
                {isNumbers ? (
                  index + 1
                ) : isIcons ? (
                  <img
                    src={ASSET_PREFIX + '/images/enter/2025/' + x.iconFilename}
                  />
                ) : (
                  <img
                    src={ASSET_PREFIX + '/images/enter/2025/enter-tick.svg'}
                  />
                )}
              </div>
              {isNumbers && <div className={styles.label}>{x.name}</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
};

// Replace the default export with this line to see all variants at once
//    export default (props: Props) => <div style={{ width: "100%" }}>{Object.values(variants).map(x => <EnterProgressBar {...props} variant={x} />)}</div>;
export default EnterProgressBar;
